"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateList = void 0;
var react_1 = __importDefault(require("react"));
var noop_1 = __importDefault(require("lodash/noop"));
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var TemplateListItem_1 = require("./TemplateListItem");
var StaggeredAnimation_1 = require("Dashboard/Layout/StaggeredAnimation");
var GhostProjectListItem_1 = __importDefault(require("Dashboard/ProjectListItem/GhostProjectListItem"));
var Types_2 = require("@CommonFrontendBackend/Permissions/Types");
var dashboard_empty_arrow_svg_1 = __importDefault(require("@ClientAssets/icons/brand/dashboard-empty-arrow.svg"));
var useTemplatesDashboardTelemetry_1 = require("Dashboard/TemplateManagementDashboard/useTemplatesDashboardTelemetry");
var c = (0, BemBuilder_1.default)("template-list");
var TemplateList = function (props) {
    var templates = props.templates, selectedTemplateId = props.selectedTemplateId, selectStyle = props.selectStyle, editCallback = props.editCallback, previewCallback = props.previewCallback, cloneCallback = props.cloneCallback, deleteCallback = props.deleteCallback, archiveCallback = props.archiveCallback, archived = props.archived, restoreCallback = props.restoreCallback, onDragStart = props.onDragStart, onDragEnd = props.onDragEnd, userIsAdmin = props.userIsAdmin, isTemplatesGallery = props.isTemplatesGallery, pageSize = props.pageSize, openAssignAutomationModal = props.openAssignAutomationModal;
    var renderGhosts = function () {
        return (react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { transitionName: "ghosts-staggered-transition", delayInMs: 50, transitionTimeoutInMs: kaleidoscope_1.AnimationDuration.Long, disableLeaveAnimation: true }, __spreadArray([], __read(Array(pageSize).keys()), false).map(function (value, i) { return (react_1.default.createElement("div", { key: i },
            react_1.default.createElement(GhostProjectListItem_1.default, null))); })));
    };
    var renderTemplates = function () {
        return templates && templates.length > 0 ? (react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { transitionName: "template-staggered-transition", delayInMs: 50, disableLeaveAnimation: true, transitionTimeoutInMs: kaleidoscope_1.AnimationDuration.Long }, templates.map(function (template) {
            var templateOptions = getTemplateOptions(template);
            return restoreCallback ? (react_1.default.createElement(TemplateListItem_1.TemplateListItem, { key: template._id, template: template, selected: selectedTemplateId === template._id, onClick: function () {
                    return restoreCallback(template._id, { confirm: true }, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.TemplateListItem);
                }, button: {
                    displaytext: "Restore",
                    callback: function () {
                        return restoreCallback(template._id, { confirm: false }, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.RestoreButton);
                    },
                }, selectStyle: selectStyle, onDragStart: onDragStart ? function (event) { return onDragStart(event, template); } : undefined, onDragEnd: onDragEnd })) : (react_1.default.createElement(TemplateListItem_1.TemplateListItem, { key: template._id, template: template, selected: selectedTemplateId === template._id, onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2, previewCallback(template, templateOptions)];
                }); }); }, options: templateOptions, selectStyle: selectStyle, onDragStart: onDragStart ? function (event) { return onDragStart(event, template); } : undefined, onDragEnd: onDragEnd, showEngagementButton: !isTemplatesGallery, openAssignAutomationModal: openAssignAutomationModal ? function () { return openAssignAutomationModal(template); } : undefined }));
        }))) : isTemplatesGallery ? (react_1.default.createElement(kaleidoscope_2.EmptyState, { isDashed: true, title: "There\u2019s nothing here!" },
            react_1.default.createElement(kaleidoscope_1.Text, { align: "center" }, userIsAdmin ? (react_1.default.createElement("span", null,
                "Change your search filters or ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/templates" }, "create a new template "),
                "to get started.")) : ("Change your search filters or ask an admin to create a new template to get started.")))) : (react_1.default.createElement(kaleidoscope_2.EmptyState, { isDashed: true, title: "There\u2019s nothing here!", subtitle: restoreCallback
                ? "Any deleted templates will be removed from your account after 30 days"
                : !archived && "Click ‘Create blank template’ to get started" }, !archived && !restoreCallback && react_1.default.createElement(kaleidoscope_2.SVG, { src: dashboard_empty_arrow_svg_1.default, className: c("empty-state-arrow") })));
    };
    var getTemplateOptions = function (template) {
        var userCanEdit = userIsAdmin || template.$userAction === Types_2.Action.All || template.$userAction === Types_2.Action.Edit;
        if (isTemplatesGallery) {
            if (userCanEdit) {
                return [
                    {
                        displaytext: "Edit this template",
                        callback: function (source) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2, editCallback(template._id, source)];
                        }); }); },
                        icon: react_1.default.createElement(icons_1.Edit, null),
                        enabled: true,
                        hideInPreview: true,
                    },
                ];
            }
            else {
                return [];
            }
        }
        else {
            return [
                {
                    displaytext: "Clone this template",
                    callback: function (source) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, cloneCallback(template._id, template.name, source)];
                    }); }); },
                    icon: react_1.default.createElement(icons_1.Copy, null),
                    enabled: true,
                },
                {
                    displaytext: "Edit this template",
                    callback: function (source) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, editCallback(template._id, source)];
                    }); }); },
                    icon: react_1.default.createElement(icons_1.Edit, null),
                    enabled: true,
                    hideInPreview: true,
                },
                {
                    displaytext: archived ? "Unarchive" : "Archive",
                    callback: function (source) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, archiveCallback(template._id, source)];
                    }); }); },
                    icon: react_1.default.createElement(icons_1.Archive, null),
                    enabled: true,
                },
                template.accessControls.delete.status === Types_1.TemplateAccessControlStatus.Allowed
                    ? {
                        displaytext: "Delete",
                        callback: function (source) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2, deleteCallback(template._id, template.name, source)];
                        }); }); },
                        destructive: true,
                        enabled: true,
                    }
                    : {
                        displaytext: template.accessControls.delete.reason,
                        callback: noop_1.default,
                        enabled: false,
                    },
            ];
        }
    };
    return (react_1.default.createElement("div", { className: c(), key: templates ? "template-staggered-transition" : "ghosts-staggered-transition" }, templates ? renderTemplates() : renderGhosts()));
};
exports.TemplateList = TemplateList;
